export var getLocalizedStoreId = function () {
    var _a, _b, _c, _d, _e;
    return (_e = (_d = (_c = (_b = (_a = global.window) === null || _a === void 0 ? void 0 : _a.THD_LOCALIZER_AUTO_INIT) === null || _b === void 0 ? void 0 : _b.Localizer) === null || _c === void 0 ? void 0 : _c.getLocalizedStore) === null || _d === void 0 ? void 0 : _d.call(_c)) === null || _e === void 0 ? void 0 : _e.storeId;
};
